import { Get } from "#src/HttpClient.ts";
import { type Pinia } from "pinia";

const controller = "/strife/v1/cases";

export async function getCase(
  pinia: Pinia,
  { id, uuid, birthdate }: { id: number; uuid: string; birthdate: string }
) {
  const params = {
    id,
    uuid,
    birthdate,
  };
  const { data } = await Get(pinia, { url: `${controller}/${id}`, params });
  return data.case;
}
